import { Routes } from '@angular/router';
import { translateRoutes } from '@app/_core/router-utility';
import { AuthService } from '@app/_services';
import { canMatchMyData } from './route-matchers/my-data-matcher';
import { environment } from '@env/environment';

export const MyDataRoutes: Routes = translateRoutes([
	{
		path: 'vana/õpingud/:id',
		loadComponent: () =>
			import('./my-data-studies-detail-view/my-data-studies-detail-view.component').then(
				(mod) => mod.MyDataStudiesDetailViewComponent,
			),
		canActivate: [AuthService],
		canMatch: [() => environment.DEV_AUTH === true],
	},
	{
		path: 'õpingud/:id',
		loadComponent: () =>
			import('./certificates/detail/certificate-detail.component').then(
				(mod) => mod.CertificateDetailComponent,
			),
		canActivate: [AuthService],
	},
	{
		path: 'minu-koolitused',
		loadComponent: () =>
			import('./my-training-list/my-training-juhan.component').then(
				(c) => c.MyTrainingJuhanComponent,
			),
		canActivate: [AuthService],
		//data: { refreshComponent: true }
	},
	{
		path: 'õpetamine/:type',
		children: [
			{
				path: '',
				loadComponent: () =>
					import('./my-data-teaching-detail-view/my-data-teaching-detail-view.component').then(
						(mod) => mod.MyDataTeachingDetailViewComponent,
					),
			},
		],
		canActivate: [AuthService],
		canMatch: [canMatchMyData],
	},
	{
		path: 'lõpudokumendid/täienduskoolitus-tunnistused',
		loadChildren: () =>
			import('./ce-certificates/ce-certificates.routes').then(
				(m) => m.CeCertificateRoutes,
			),
		canActivate: [AuthService],
	},
	{
		path: 'lõpudokumendid/tunnistused',
		pathMatch: 'full',
		loadComponent: () =>
			import('./certificates/certificates-list.component').then(
				(m) => m.CertificatesListComponent,
			),
		canActivate: [AuthService],
	},
	{
		path: 'lõpudokumendid/tunnistused/:id',
		loadChildren: () =>
			import('../certificates/containers/certificates-dashboard-detail/certificates-dashboard-detail.module').then(
				(m) => m.CertificatesDashboardDetailModule,
			),
		data: {
			from: 'final_documents',
		},
	},
	{
		path: 'lõpudokumendid/:certificateNr/:accessorCode',
		loadComponent: () =>
			import('../my-data/final-document/final-document.component').then(
				(c) => c.MyDataFinalDocument,
			),
		data: {
			from: 'final_documents',
		},
	},
	{
		path: 'lõpudokumendid/:id',
		loadComponent: () =>
			import('../my-data/final-document/final-document.component').then(
				(c) => c.MyDataFinalDocument,
			),
		data: {
			from: 'final_documents',
		},
	},
	{
		path: 'eksamid',
		loadChildren: () =>
			import('./exams/exams.routes').then((res) => res.ExamRoutes),
		canActivate: [AuthService],
		canMatch: [canMatchMyData],
	},
	{
		path: 'kutse-tunnistused',
		loadComponent: () =>
			import('./professional-certificates/professional-certificates-list.component').then(
				(res) => res.ProfessionalCertificatesListComponent,
			),
		canActivate: [AuthService],
		canMatch: [canMatchMyData],
	},
	{
		path: ':id',
		loadComponent: () =>
			import('./my-data-view/my-data-view.component').then(
				(mod) => mod.MyDataViewComponent,
			),
		canMatch: [canMatchMyData],
	},
]);
